module.exports = __webpack_public_path__ + "components/resort-webcams/static/webcam_placeholder-28571695464381bba7db79fc143d414e.jpg";